/**
 * Org-member rows (from the org detail payload's `users`) → context-stack
 * switcher options for the workspace sidebar's user dropdown.
 *
 * Structural param type on purpose: both callers already hold the org detail
 * response, and depending on the generated type here would couple this util to
 * codegen output it only needs four fields of.
 */

import type { ContextSwitcherOption } from '../components/org-page-redesign/WorkspaceSidebar';

interface OrgMemberLike {
  user_id: string;
  name?: string | null;
  email?: string | null;
  status?: string | null;
}

export function buildUserSwitcherOptions(
  users: OrgMemberLike[] | undefined,
): ContextSwitcherOption[] {
  if (!users?.length) return [];
  return [...users]
    .sort((a, b) =>
      (a.name || a.email || '').localeCompare(b.name || b.email || '', undefined, {
        sensitivity: 'base',
      }),
    )
    .map(user => {
      const email = user.email || undefined;
      return {
        id: user.user_id,
        label: user.name || email || user.user_id,
        secondary:
          user.status === 'inactive' ? [email, '(inactive)'].filter(Boolean).join(' ') : email,
      };
    });
}
